<template>
    <div>
        <v-layout
            v-for="(item, idx) in audioEngines"
            :key="idx">
            <template>
                <div style="display: flex; align-items: center; justify-content: space-between; height: 30px">
                    <v-checkbox
                        hide-details
                        color="#0052CC"
                        v-model="configs"
                        :label="item.name"
                        :value="item.key"
                        :readonly="!editable"
                    ></v-checkbox>
                    <div v-if="editable && configs.includes(item.key)" class="btn-icon-2"
                         @click="openConfigEditor(item)">
                        <img src="/img/setting.svg" style="transform: scale(1.1)"
                             alt="icon-setting">
                    </div>
                </div>
            </template>
        </v-layout>
        <AudioEngineConfigEditor
            ref="AudioEngineConfigEditor"
            @updateConfig="updateConfig"
        ></AudioEngineConfigEditor>
    </div>
</template>
<script>
import ScenarioService from "@/services/scenario.service";
import {mapState} from "vuex";
import lodash from "lodash";
import AudioEngineConfigEditor from "@/views/Scenario/NodeEditor/common/AudioEngineConfigEditor";
import logo from "@/modules/fptai/components/Logo";

export default {
    name: "AudioEngineEditor",
    components: {AudioEngineConfigEditor},
    props: {
        value: {
            type: Object,
            default: () => ({}),
        },
        editable: {
            type: Boolean,
            default: true
        },
        nodeID: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            configs: [],
            audioEngineConfigs: [],
            voiceDNAConfigs: [],
            currentEditKey: "",
            currentEditConfig: {},
            newEditConfig: {},
            editEngineConfigs: {}
        }
    },
    computed: {
        ...mapState({
            audioEngines: state => state.scenario.audioEngineList
        }),
        isEditable() {
            if (typeof this.editable === 'boolean') {
                return this.editable
            }

            return ScenarioService.isEditable() && ScenarioService.isModeEditing()
        }
    },
    methods: {
        convertData() {
            let lst = []
            if (!this.value) {
                return
            }
            Object.keys(this.value).forEach(key => {
                switch (key) {
                    case 'audio_engine':
                        this.audioEngineConfigs = JSON.parse(this.value["audio_engine"])
                        lst.push(...Object.keys(this.audioEngineConfigs))
                        break
                    case 'voicedna':
                        this.voiceDNAConfigs = JSON.parse(this.value["voicedna"])
                        lst.push(...Object.keys(this.voiceDNAConfigs))
                        break
                    default:
                        break
                }
            })
            this.configs = lst
        },
        openConfigEditor(item) {
            let configKey = item.key
            let engine = this.audioEngines.find(obj => obj.key === configKey)

            this.currentEditKey = configKey
            let defaultValue = this.createDefaultValue(configKey)

            if (configKey.startsWith('voicedna')) {
                if (!this.voiceDNAConfigs[configKey]) {
                    this.voiceDNAConfigs[configKey] = defaultValue
                }
                this.$refs.AudioEngineConfigEditor.open(this.voiceDNAConfigs[configKey], engine)
            }

            if (configKey.startsWith('audio')) {
                if (!this.audioEngineConfigs[configKey]) {
                    this.audioEngineConfigs[configKey] = defaultValue
                }
                this.$refs.AudioEngineConfigEditor.open(this.audioEngineConfigs[configKey], engine)
            }
        },
        updateConfig(item) {
            this.newEditConfig = item
        },
        createDefaultValue(config) {
            let defaultValue = {
                input: {},
                output: {}
            }

            let engine = this.audioEngines.find(obj => obj.key === config)
            if (engine && engine.input) {
                engine.input.filter(i => i.required).forEach(item => {
                    if (item.value?.length) {
                        defaultValue.input[item.key] = item.value[0]
                    }
                })
            }
            
            return defaultValue
        },
        parseNewConfigs(newConfigs) {
            let oldAudioEngine = this.value['audio_engine'] ? JSON.parse(this.value['audio_engine']) : {}
            let oldVoiceDNA = this.value['voicedna'] ? JSON.parse(this.value['voicedna']) : {}

            let newAudioEngine = {}
            let newVoiceDNA = {}

            newConfigs.forEach(config => {
                let defaultValue = this.createDefaultValue(config)

                if (config.startsWith('audio')) {
                    newAudioEngine[config] = oldAudioEngine[config] ? oldAudioEngine[config] : defaultValue
                    return
                }

                if (config.startsWith('voicedna')) {
                    newVoiceDNA[config] = oldVoiceDNA[config] ? oldVoiceDNA[config] : defaultValue
                }
            })
            return {newAudioEngine: newAudioEngine, newVoiceDNA: newVoiceDNA}
        },
    },
    watch: {
        value: {
            immediate: true,
            deep: true,
            handler: function () {
                this.convertData()
            }
        },
        configs: {
            deep: true,
            immediate: true,
            handler: function (newConfigs) {
                // setting value
                let {newAudioEngine, newVoiceDNA} = this.parseNewConfigs(newConfigs)

                let newValue = this.$utils.cloneObject(this.value)

                if (Object.keys(newAudioEngine).length > 0) {
                    newValue['audio_engine'] = JSON.stringify(newAudioEngine)
                } else {
                    delete newValue['audio_engine']
                }

                if (Object.keys(newVoiceDNA).length > 0) {
                    newValue['voicedna'] = JSON.stringify(newVoiceDNA)
                } else {
                    delete newValue['voicedna']
                }

                if (!lodash.isEqual(newValue, this.value)) {
                    this.$emit('input', newValue)
                    this.$emit('save')
                }
            }
        },
        newEditConfig: {
            deep: true,
            handler: function (newConfigs) {
                let setting = this.$utils.cloneObject(this.value)
                if (newConfigs.key.startsWith('voicedna')) {
                    this.voiceDNAConfigs[newConfigs.key] = newConfigs.config
                    setting['voicedna'] = JSON.stringify(this.voiceDNAConfigs)
                }

                if (newConfigs.key.startsWith('audio')) {
                    this.audioEngineConfigs[newConfigs.key] = newConfigs.config
                    setting['audio_engine'] = JSON.stringify(this.audioEngineConfigs)
                }

                this.currentEditKey = ""
                this.currentEditConfig = {}
                this.$emit('input', setting)
                this.$emit('save')
            }
        },
    }
}
</script>
